import { Button, Flex, Tooltip } from 'antd'
import { cx } from 'antd-style'

import type { BulkAction } from './BulkActionsBar'
import { useStyles } from './styles'

type Props = {
  actions: BulkAction[]
  onSelect: (action: BulkAction) => void
}

export const BulkActionsOverflow = ({ actions, onSelect }: Props) => {
  const { styles } = useStyles()

  return (
    <Flex vertical className={styles.overflowMenu}>
      {actions.map((action) => {
        const {
          title: blockedReason,
          className,
          icon,
          onClick: _onClick,
          ...buttonProps
        } = action.buttonProps ?? {}

        return (
          <Tooltip key={action.title} title={blockedReason}>
            <span className={styles.overflowTrigger}>
              <Button
                type="text"
                block
                {...buttonProps}
                icon={icon}
                aria-label={action.title}
                className={cx(styles.overflowItem, className)}
                classNames={{ root: styles.overflowItem }}
                onClick={() => onSelect(action)}
              >
                {action.title}
              </Button>
            </span>
          </Tooltip>
        )
      })}
    </Flex>
  )
}
